export default class AkaponCommonModalHeaderMaster {
  constructor() {
    this.MODAL_BACK_SENTINEL = '__NO_MODAL__';
    this.modalBackStack = [];
    this.pendingStackResetTimer = null;
    this.backNavigationUnlockTimer = null;
    this.isBackNavigationLocked = false;
    this.isInitialized = false;
  }

  isInviteMemberPopup(modalEl) {
    return !!modalEl && (
      modalEl.id === 'popupInviteMember' ||
      modalEl.classList?.contains('popup-invite-member')
    );
  }

  hasVisibleModalLike() {
    const invitePopup = document.getElementById('popupInviteMember');
    const isInvitePopupVisible = !!invitePopup
      && !invitePopup.classList.contains('d-none')
      && window.getComputedStyle(invitePopup).display !== 'none'
      && window.getComputedStyle(invitePopup).visibility !== 'hidden';

    return isInvitePopupVisible || document.querySelectorAll('.modal.show').length > 0;
  }

  clearPendingStackReset() {
    if (!this.pendingStackResetTimer) return;

    clearTimeout(this.pendingStackResetTimer);
    this.pendingStackResetTimer = null;
  }

  scheduleModalBackStackReset() {
    if (this.pendingStackResetTimer) return;

    this.pendingStackResetTimer = setTimeout(() => {
      this.pendingStackResetTimer = null;

      if (this.hasVisibleModalLike()) return;

      this.modalBackStack.length = 0;
    }, 800);
  }

  lockBackNavigation(duration = 300) {
    this.isBackNavigationLocked = true;

    if (this.backNavigationUnlockTimer) {
      clearTimeout(this.backNavigationUnlockTimer);
    }

    this.backNavigationUnlockTimer = setTimeout(() => {
      this.isBackNavigationLocked = false;
      this.backNavigationUnlockTimer = null;
    }, duration);
  }

  unlockBackNavigation() {
    this.isBackNavigationLocked = false;

    if (!this.backNavigationUnlockTimer) return;

    clearTimeout(this.backNavigationUnlockTimer);
    this.backNavigationUnlockTimer = null;
  }

  getRecentFileMenuModalId(maxAge = 10000) {
    const id = window.__tmLastFileMenuModalId || '';
    const ts = Number(window.__tmLastFileMenuModalTs || 0);

    if (!id) return '';
    if (ts > 0 && Date.now() - ts > maxAge) return '';

    return id;
  }

  ensureRecentFileMenuBeforeInvite(inviteModalId) {
    const recentFileMenuId = this.getRecentFileMenuModalId();
    if (!recentFileMenuId || recentFileMenuId === inviteModalId) return;

    const inviteModal = document.getElementById(inviteModalId);
    if (inviteModal) {
      inviteModal.setAttribute('data-tm-parent-modal-id', recentFileMenuId);
    }

    if (!this.modalBackStack.length) {
      this.modalBackStack.push({ id: this.MODAL_BACK_SENTINEL });
    }

    const inviteIndex = this.modalBackStack.findIndex((item) => item.id === inviteModalId);
    const menuIndex = this.modalBackStack.findIndex((item) => item.id === recentFileMenuId);

    if (menuIndex >= 0 && inviteIndex >= 0 && menuIndex < inviteIndex) return;

    if (menuIndex >= 0) {
      this.modalBackStack.splice(menuIndex, 1);
    }

    const nextInviteIndex = this.modalBackStack.findIndex((item) => item.id === inviteModalId);
    const insertAt = nextInviteIndex >= 0 ? nextInviteIndex : this.modalBackStack.length;
    this.modalBackStack.splice(insertAt, 0, { id: recentFileMenuId });
  }

  getFallbackPrevModal(modalEl) {
    if (!modalEl) return null;

    const candidateIds = [];
    const explicitParentId = modalEl.getAttribute?.('data-tm-parent-modal-id') || '';
    if (explicitParentId) {
      candidateIds.push(explicitParentId);
    }

    if (this.isInviteMemberPopup(modalEl)) {
      const recentFileMenuId = this.getRecentFileMenuModalId();
      if (recentFileMenuId) {
        candidateIds.push(recentFileMenuId);
      }
    }

    for (const candidateId of candidateIds) {
      if (!candidateId || candidateId === modalEl.id) continue;

      const candidateModal = document.getElementById(candidateId);
      if (candidateModal) return candidateModal;
    }

    return null;
  }

  navigateBackToModal(modalEl, prevModal, resetStackToPrev = false) {
    if (!modalEl || !prevModal) return false;

    if (resetStackToPrev) {
      const prevId = prevModal.id || prevModal.getAttribute('data-tm-modal-key') || '';
      this.modalBackStack.length = 0;
      if (prevId) {
        this.modalBackStack.push({ id: this.MODAL_BACK_SENTINEL }, { id: prevId });
      }
    }

    this.lockBackNavigation(500);

    if (this.isInviteMemberPopup(modalEl)) {
      this.hideModalCompat(modalEl);
      setTimeout(() => {
        this.showModalCompat(prevModal);
        this.unlockBackNavigation();
      }, 30);
      return true;
    }

    if (modalEl.id) {
      $(`#${modalEl.id}`).one('hidden.bs.modal', () => {
        setTimeout(() => {
          this.showModalCompat(prevModal);
          this.unlockBackNavigation();
        }, 30);
      });
    }

    this.hideModalCompat(modalEl);
    return true;
  }

  updateModalBackStackFrom(modalsNodeList) {
    const modals = Array.from(modalsNodeList || []);
    if (!modals.length) {
      this.scheduleModalBackStackReset();
      return;
    }

    this.clearPendingStackReset();

    const top = modals[modals.length - 1];
    if (!top) return;

    const id = top.id || top.getAttribute('data-tm-modal-key') || '';
    if (!id) return;

    const isInvitePopup = this.isInviteMemberPopup(top);

    const last = this.modalBackStack[this.modalBackStack.length - 1];

    if (!this.modalBackStack.length) {
      this.modalBackStack.push({ id: this.MODAL_BACK_SENTINEL });
      if (isInvitePopup) {
        this.ensureRecentFileMenuBeforeInvite(id);
      }
      this.modalBackStack.push({ id });
      return;
    }

    if (isInvitePopup) {
      this.ensureRecentFileMenuBeforeInvite(id);
    }

    if (last && last.id === id) return;

    const existingIndex = this.modalBackStack.findIndex((item) => item.id === id);
    if (existingIndex >= 0) {
      this.modalBackStack.splice(existingIndex + 1);
      return;
    }

    this.modalBackStack.push({ id });
  }

  showModalCompat(modalEl) {
    if (!modalEl || !modalEl.id) return;

    if (this.isInviteMemberPopup(modalEl)) {
      $(modalEl).removeClass('d-none').show();
      return;
    }

    $(`#${modalEl.id}`).modal('show');
  }

  hideModalCompat(modalEl) {
    if (!modalEl) return;

    if (this.isInviteMemberPopup(modalEl)) {
      if (typeof Visiable !== 'undefined' && typeof Visiable.hide === 'function') {
        Visiable.hide('#popupInviteMember');
      } else {
        $(modalEl).addClass('d-none').hide();
      }
      $('.modal-backdrop').remove();
      return;
    }

    if (modalEl && modalEl.id === 'personInChargeOfObject') {
      TaskPic.confirmCloseModalSettingMember();
      return;
    }

    const $m = $(modalEl);
    if (modalEl.id && typeof $m.modal === 'function') {
      $m.modal('hide');
    } else {
      $m.removeClass('show').hide();
      $('.modal-backdrop')?.hide();
    }
  }

  goBackFromModal(modalEl) {
    if (!modalEl) return;
    // 作成完了モーダルは前のモーダルに戻さず、そのまま閉じる
    const NO_BACK_MODAL_IDS = ['modalAfterCreateProject', 'afterCreateTaskProjectModalFromTwoOptions'];
    if (modalEl.id && NO_BACK_MODAL_IDS.includes(modalEl.id)) {
      this.modalBackStack.length = 0;
      this.hideModalCompat(modalEl);
      return;
    }

    const id = modalEl.id || modalEl.getAttribute('data-tm-modal-key') || '';
    if (!id) {
      this.hideModalCompat(modalEl);
      return;
    }

    const fallbackPrevModal = this.getFallbackPrevModal(modalEl);

    let idx = this.modalBackStack.length - 1;
    while (idx >= 0 && this.modalBackStack[idx].id !== id) {
      idx--;
    }

    if (idx < 0) {
      if (fallbackPrevModal) {
        this.navigateBackToModal(modalEl, fallbackPrevModal, true);
        return;
      }
      this.hideModalCompat(modalEl);
      return;
    }

    this.modalBackStack.splice(idx);

    let prev = this.modalBackStack[this.modalBackStack.length - 1];

    if ((!prev || prev.id === this.MODAL_BACK_SENTINEL) && fallbackPrevModal) {
      const fallbackPrevId = fallbackPrevModal.id || fallbackPrevModal.getAttribute('data-tm-modal-key') || '';
      if (fallbackPrevId) {
        this.modalBackStack.length = 0;
        this.modalBackStack.push({ id: this.MODAL_BACK_SENTINEL }, { id: fallbackPrevId });
        prev = this.modalBackStack[this.modalBackStack.length - 1];
      }
    }

    if (!prev || prev.id === this.MODAL_BACK_SENTINEL) {
      this.modalBackStack.length = 0;
      this.lockBackNavigation();
      this.hideModalCompat(modalEl);
      return;
    }

    const prevModal = document.getElementById(prev.id) || fallbackPrevModal;
    if (prevModal) {
      this.navigateBackToModal(modalEl, prevModal);
      return;
    }

    this.hideModalCompat(modalEl);
  }

  handleBackClick(event) {
    if (this.isBackNavigationLocked) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      return;
    }

    const modal = event.currentTarget.closest('.modal')
      || event.currentTarget.closest('#popupInviteMember, .popup-invite-member');
    if (!modal) {
      if ($(event.currentTarget).parents('.div-popup-invite-member').length > 0) {
        Visiable.hide('#popupInviteMember');
        $('.modal-backdrop').remove();
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const uploadModalDialog = modal.querySelector(
      '#animation-uploader-modal-video, #animation-uploader-modal-image, #capture-url-select, #animation-get-url-modal'
    );
    const modalBackEvent = new CustomEvent('tm-modal-back-click', {
      bubbles: true,
      cancelable: true,
      detail: {
        modalId: modal.id || (uploadModalDialog && uploadModalDialog.id) || modal.getAttribute('data-tm-modal-key') || '',
      },
    });

    modal.dispatchEvent(modalBackEvent);

    if (!modalBackEvent.defaultPrevented) {
      this.goBackFromModal(modal);
    }

    const activeClass = 'tm-allfiles-active-row';
    document.querySelectorAll(`.${activeClass}`).forEach((el) => el.classList.remove(activeClass));
  }

  bindModalMenuCloseFallbackOnce() {
    if (document.body.dataset.tmModalMenuCloseFallback === '1') return;
    document.body.dataset.tmModalMenuCloseFallback = '1';

    document.addEventListener('click', (ev) => {
      const a = ev.target && ev.target.closest
        ? ev.target.closest('[id^="modalMenu-"].modal a.dropdown-item[onclick*="hideModalForElement"]')
        : null;
      if (!a) return;

      const modal = a.closest('[id^="modalMenu-"].modal');
      if (!modal) return;

      setTimeout(() => {
        const cs = getComputedStyle(modal);
        if (cs.display !== 'none') {
          this.hideModalCompat(modal);
        }
      }, 0);
    }, true);
  }

  init() {
    if (this.isInitialized) return;
    this.isInitialized = true;

    this.bindModalMenuCloseFallbackOnce();

    // Use capture phase to bypass stopPropagation in legacy ERB files
    document.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest
        ? e.target.closest('.tm-file-header-back-btn, .tm-file-header-back-btn-sp')
        : null;
      if (!btn) return;

      this.handleBackClick({
        currentTarget: btn,
        preventDefault: () => e.preventDefault(),
        stopPropagation: () => e.stopPropagation(),
        stopImmediatePropagation: () => e.stopImmediatePropagation(),
      });
    }, true);
  }
}
